var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67407 5.25031H14.9055C15.3068 5.25039 15.6731 5.48596 15.844 5.86554C16.0054 6.22474 15.9486 6.65029 15.6516 6.98761L12.7815 9.77179L12.554 9.99347V10.3099L12.5549 17.7034V17.7122C12.5612 18.263 12.1484 18.7028 11.6213 18.7454L11.5354 18.7484C11.4074 18.7483 11.2843 18.7281 11.1565 18.678L11.0266 18.6185L9.54907 17.7845L9.54126 17.7806L9.53442 17.7767L9.41821 17.7034C9.16093 17.5153 9.0022 17.2083 9.0022 16.8675L9.00122 10.2864V9.97101L8.77563 9.75031L5.93774 6.9798C5.65775 6.69289 5.57627 6.26035 5.74438 5.86359C5.90505 5.48449 6.25852 5.25044 6.67407 5.25031Z",
    stroke: "#231E1F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4675 15.5457C18.8127 15.5457 19.0925 15.8255 19.0925 16.1707V16.3309C19.0925 16.676 18.8127 16.9559 18.4675 16.9559H14.7175C14.3724 16.9559 14.0925 16.676 14.0925 16.3309V16.1707C14.0925 15.8255 14.3724 15.5457 14.7175 15.5457H18.4675ZM18.4675 13.2508C18.8126 13.2508 19.0923 13.5308 19.0925 13.8758V14.0369C19.0925 14.3821 18.8127 14.6619 18.4675 14.6619H14.7175C14.3724 14.6619 14.0925 14.3821 14.0925 14.0369V13.8758C14.0928 13.5308 14.3725 13.2508 14.7175 13.2508H18.4675ZM18.4675 10.9578C18.8127 10.9578 19.0925 11.2376 19.0925 11.5828V11.744C19.0924 12.089 18.8126 12.369 18.4675 12.369H14.7175C14.3725 12.369 14.0927 12.089 14.0925 11.744V11.5828C14.0925 11.2376 14.3724 10.9578 14.7175 10.9578H18.4675Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4a7de7da5de434ff6d7362d13f076353.svg";
export { ForwardRef as ReactComponent };